module.exports = __webpack_public_path__ + "static/media/logo.dark.0c576d1a.png";